import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchPropertyFilterValues, handleFilter } from '../../store/actions';
import { storage } from '../../config';
import { PROPERTY_TYPES } from '../../constants';
import { ViewerSecondaryColorUserStyle } from '../UserCustomization';

import PropertyFilterWrapper from '../Properties/PropertyFilter/PropertyFilterWrapper';
import FlipCardContainer from '../FlipCard/FlipCardContainer';
import FlipCard from '../FlipCard/FlipCard';
import TabToggle from '../TabToggle/TabToggle';
import svgInline from '../SvgInline/SvgInline';

import closeIcon from './icon-close.svg';
import './filterWrapper.css';

export class FilterWrapperComponent extends Component {
  constructor(props) {
    super(props);
    this.handleToggleClick = this.handleToggleClick.bind(this);
  }
  componentDidMount() {
    const {
      buildingsFilterValues,
      getBuildingsFilterValues,
      getSitesFilterValues,
      organizationId,
      sitesFilterValues,
    } = this.props;

    // This request is cheap so just getting all for now
    const hasSitesFilters = Object.keys(sitesFilterValues).length !== 0;
    const hasBuildingsFilters = Object.keys(buildingsFilterValues).length !== 0;
    if (!hasSitesFilters || !hasBuildingsFilters) {
      getBuildingsFilterValues(organizationId);
      getSitesFilterValues(organizationId);
    }
  }

  handleToggleClick(selectedTab) {
    this.props.onFilterChange(selectedTab);
  }

  render() {
    const {
    filterDisplay,
    buildingsFilterValues,
    sitesFilterValues,
    onCloseClick,
    organizationId,
  } = this.props;
    const flip = (filterDisplay === 'sites');

    return (
      <div className="filter-wrapper">
        <ViewerSecondaryColorUserStyle domStyle="backgroundColor">
          <div className="toolbox-header">
            <div>Search Properties</div>
            <div className="toolbox-actions">
              <div className="filter-toggle detail-toggle">
                <TabToggle
                  handleClick={this.handleToggleClick}
                  name="detailToggle"
                  checked={flip}
                  leftTab="Buildings"
                  rightTab="Sites"
                  selectedTab={filterDisplay}
                />
              </div>
              <a
                className="toolbox-close"
                onClick={() => { onCloseClick(); }}
                tabIndex="0"
              >
                {svgInline(closeIcon)}
              </a>
            </div>
          </div>
        </ViewerSecondaryColorUserStyle>
        <FlipCardContainer flip={flip}>
          <FlipCard side="front">
            <div>
              {
                Object.keys(buildingsFilterValues).length === 0 &&
                <img
                  alt="loading gif"
                  src={`${storage.distPath}/loading.gif`}
                />
              }
              {
                flip === false &&
                Object.keys(buildingsFilterValues).length > 0 &&
                (
                  <PropertyFilterWrapper
                    filterValues={buildingsFilterValues}
                    propertyType={PROPERTY_TYPES.BUILDINGS}
                    organizationId={organizationId}
                  />
                )
              }
            </div>
          </FlipCard>
          <FlipCard side="back">
            <div>
              {
                Object.keys(sitesFilterValues).length === 0 &&
                <img
                  alt="loading gif"
                  src={`${storage.distPath}/loading.gif`}
                />
              }
              {
                flip === true &&
                Object.keys(sitesFilterValues).length > 0 &&
                (
                  <PropertyFilterWrapper
                    filterValues={sitesFilterValues}
                    propertyType={PROPERTY_TYPES.SITES}
                    organizationId={organizationId}
                  />
                )
              }
            </div>
          </FlipCard>
        </FlipCardContainer>
      </div>
    );
  }
}

FilterWrapperComponent.propTypes = {
  buildingsFilterValues: PropTypes.object,
  getBuildingsFilterValues: PropTypes.func.isRequired,
  getSitesFilterValues: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  filterDisplay: PropTypes.string.isRequired,
  organizationId: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  sitesFilterValues: PropTypes.object,
};

/* istanbul ignore next */
const mapStateToProps = state => {
  return ({
    buildingsFilterValues: state.buildings.filterValues,
    sitesFilterValues: state.sites.filterValues,
    organizationId: state.organizationId,
  });
};

/* istanbul ignore next */
const mapDispatchToProps = dispatch => {
  return ({
    getBuildingsFilterValues: org => { dispatch(fetchPropertyFilterValues(org, 'buildings')); },
    getSitesFilterValues: org => { dispatch(fetchPropertyFilterValues(org, 'sites')); },
    onCloseClick: () => dispatch(handleFilter('close')),
    onFilterChange: propertyType => dispatch(handleFilter('open', propertyType)),
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterWrapperComponent);



// WEBPACK FOOTER //
// ./src/components/Filter/FilterWrapper.js